import { useMemo } from 'react';

import { useDataProvider } from '@work4all/data';

import { LookUp } from '@work4all/models/lib/Classes/LookUp.entity';
import { DataRequest } from '@work4all/models/lib/DataProvider';
import { EMode } from '@work4all/models/lib/Enums/EMode.enum';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';
import { LookupType } from '@work4all/models/lib/Enums/LookupType.enum';

const LOOKUP_DATA: LookUp<EMode.query> = {
  id: null,
  name: null,
  standard: null,
  closedStatus: null,
  lookupType: null,
  color: null,
  value: null,
  valueDouble: null,
  textValue: null,
  showAs: null,
  symbol: null,
  groupView: null,
  objKind: null,
  hexColorPair: null,
  aboVertragAliasKopftext: null,
  aboVertragAliasNotiz: null,
  isVacationKindForShortTimeWork: null,
  userId: null,
  lookUpId: null,
  insertTime: null,
  updateTime: null,
};

interface UseLookupsOptions {
  type: LookupType;
  ids?: number[];
}

export function useLookups(options: UseLookupsOptions) {
  const { type, ids } = options;

  const request = useMemo<DataRequest>(() => {
    const vars: { type: LookupType; codes?: number[] } = { type, codes: ids };

    return {
      data: LOOKUP_DATA,
      entity: Entities.lookUp,
      vars,
    };
  }, [type, ids]);

  const { data, pending, refetch, loading } = useDataProvider<LookUp>(request);

  const filteredData = useMemo(() => {
    if (!data || !ids) {
      return data;
    }

    return Array.isArray(data)
      ? data.filter((item) => ids.includes(item.id))
      : data;
  }, [data, ids]);

  return {
    data: filteredData,
    pending,
    refetch,
    loading,
  };
}
